import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { MeasuredCookieType } from '../../../../Measured/redux/types';
import { MeasuredContainer, measuredDefaultSize } from '../../../../Measured';
import StandardThumb from '../../../../DeviationViews/Thumb/Standard';
import MobileThumb from '../../../../DeviationViews/Thumb/Mobile';
import s from './DeviationMobileList.scss';
/** Sidebar block layout id 5 */
var DeviationMobileList = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    var isMLT = block.contentType === 'recommended';
    var devpage_mobile_mlt_thumbs = useFlag('devpage_mobile_mlt_thumbs');
    var mlt9 = useFlag('devpage_mobile_mlt9');
    var deviations = mlt9 && isMLT ? block.deviations : (_b = block.deviations) === null || _b === void 0 ? void 0 : _b.slice(0, 5);
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement("div", { className: s['root'] },
            React.createElement(DeviationDuperbrowseContext, { streamId: "sidebar-mobilelist-".concat(block.contentType), deviations: deviations !== null && deviations !== void 0 ? deviations : [], parent: {
                    typeId: getDeviationResourceType(parentDeviation),
                    itemId: parentDeviation.deviationId,
                } },
                React.createElement(MeasuredContainer, { cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR, cookieDim: 'width', defaultSize: measuredDefaultSize, listenOnWindow: true, limitToParentWidth: true, measureWindow: true }, function (_a) {
                    var container = _a.container;
                    return deviations === null || deviations === void 0 ? void 0 : deviations.map(function (deviation) {
                        return devpage_mobile_mlt_thumbs && isMLT ? (React.createElement(MobileThumb, { key: deviation.deviationId, className: s['thumb'], deviation: deviation, width: container
                                ? container.width
                                : measuredDefaultSize.mobile.width, 
                            // heads-up: this includes the controls above and below the image
                            height: 400 })) : (React.createElement(StandardThumb, { key: deviation.deviationId, deviation: deviation, width: container
                                ? container.width
                                : measuredDefaultSize.mobile.width, height: 239, className: s['thumb'] }));
                    });
                })))));
};
DeviationMobileList.displayName = 'DeviationMobileList';
export default DeviationMobileList;
//# sourceMappingURL=DeviationMobileList.js.map